var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40.0001C31.0457 40.0001 40 31.0458 40 20.0001C40 8.95437 31.0457 6.10352e-05 20 6.10352e-05C8.9543 6.10352e-05 0 8.95437 0 20.0001C0 31.0458 8.9543 40.0001 20 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 0C12.0709 0 5.21962 4.61445 1.98462 11.3044H38.0155C34.7806 4.61445 27.9292 0 20.0001 0V0Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 40.0001C27.9292 40.0001 34.7806 35.3856 38.0156 28.6957H1.98462C5.21962 35.3856 12.0709 40.0001 20.0001 40.0001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.9565C23.8419 26.9565 26.9564 23.842 26.9564 20C26.9564 16.158 23.8419 13.0435 19.9999 13.0435C16.158 13.0435 13.0435 16.158 13.0435 20C13.0435 23.842 16.158 26.9565 19.9999 26.9565Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.3478C22.4013 24.3478 24.3478 22.4013 24.3478 20C24.3478 17.5988 22.4013 15.6522 20 15.6522C17.5988 15.6522 15.6522 17.5988 15.6522 20C15.6522 22.4013 17.5988 24.3478 20 24.3478Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.6349L21.3413 17.6769L24.6463 17.3175L22.6825 20L24.6463 22.6826L21.3413 22.3232L20 25.3652L18.6586 22.3232L15.3536 22.6825L17.3174 20L15.3536 17.3175L18.6586 17.6769L20 14.6349Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.a0131581090c3783e602da00ba96ebc8.svg";
export { ForwardRef as ReactComponent };